// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pFAHiQrMajqg2M {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-bottom: var(--ds-space-0, 0);
  line-height: 32px;
}
.pFAHiQrMajqg2M .QAN3qCJTQYh3lF,
.pFAHiQrMajqg2M .Bb8_HP8OnxmP4R:hover {
  color: var(--dynamic-star);
}
.pFAHiQrMajqg2M .hC6lh8l_d_qype:hover > .hC6lh8l_d_qype {
  transform: scale(1.2);
  cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardStarButton": `pFAHiQrMajqg2M`,
	"starred": `QAN3qCJTQYh3lF`,
	"unstarred": `Bb8_HP8OnxmP4R`,
	"icon": `hC6lh8l_d_qype`
};
export default ___CSS_LOADER_EXPORT___;
